import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'

import { PeriodSchema } from '@/modules/tasks/service/repeatable-task-service.ts'

export type SchedulerEditorValues = z.infer<typeof Schema>

export const defaultValues: SchedulerEditorValues = {
  name: '',
  detail: '',
  assignees: [],
  endDate: null,
  rate: null,
  hourlyDueDuration: 0,
  id: null,
  priority: null,
  period: 'Daily',
  projectId: null,
  teamId: null,
  rateDayOfMonth: 0,
  rateMonth: 0,
  rateDaysOfWeek: [] as Weekday[],
}

const WeekdayEnum = z.enum([
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
])

type Weekday = z.infer<typeof WeekdayEnum>

const Schema = z.object({
  id: z.number().nullish().optional(),
  name: z.string().min(1, { message: 'Task title is required.' }),
  detail: z.string().nullish().optional().default(''),
  priority: z.string().nullish(),
  teamId: z.number().nullish(),
  projectId: z.number().nullish(),
  assignees: z.array(z.number()).nullish(),
  period: PeriodSchema.nullish(),
  rate: z.array(z.number()).nullish(),
  hourlyDueDuration: z.coerce.number().nullish(),
  endDate: z.string().nullish(),
  rateDayOfMonth: z.number().nullish(),
  rateMonth: z.number().nullish(),
  rateDaysOfWeek: z.array(WeekdayEnum).nullish(),
})

export const schedulerResolver = zodResolver(Schema)
